module.exports = __webpack_public_path__ + "static/media/memberIcon.8964b780.svg";